import { render, staticRenderFns } from "./TypeSponsor.vue?vue&type=template&id=6123f85e&"
import script from "./TypeSponsor.vue?vue&type=script&lang=js&"
export * from "./TypeSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports